import React from 'react';
import AccountSingleButton from '../AccountSingleButton'
import { useSubscription } from '../../../hooks/subscriptions/queries';
import { useCurrentUser } from '../../../hooks/users/queries';
import { isOwner } from '../../../utils/subscriptionUtils';

const BillingPastDueBlocker = ({ onClick }) => {
  const { data: subscription } = useSubscription();
  const { data: currentUser } = useCurrentUser();
  const isSubscriptionOwner = isOwner(subscription, currentUser?.id);
  
  const getText = (isSubscriptionOwner) => {
    if (isSubscriptionOwner) {
      return "Your subscription is past due. Please update your payment information to continue using Delve."
    } else {
      return "Your subscription is past due. Please ask your team owner to renew the subscription."
    }
  }

  const text = getText(isSubscriptionOwner);

  return (
    <AccountSingleButton
      onClick={onClick}
      loading={false}
      header="Subscription is Past Due"
      button='Go to Accounts Page'
      body={<p>{text}</p>}
      hideTerms={true}
    />
  );
}

export default BillingPastDueBlocker;